
import styled from 'styled-components';
import { SectionWithImageAndCtaCardProps } from './query';
import CtaCard from '@/components/molecules/CtaCard';
import Title_v2 from '@/components/molecules/Title/index';
import TextWithImage from '@/components/wrappers/TextWithImage';
import devices from '@/utilities/devices';
import { renderUnderline } from '@/utilities/functions';

const CardsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	width: 100%;

	> div {
		margin: 2rem 1rem 3rem;
	}
	@media screen and (${devices.mobile}) {
		flex-direction: column;
		> div {
			margin: 1rem 0rem;
		}
	}

	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		flex-direction: column;
		justify-content: center;
		align-items: center;
		> div {
			margin: 1rem 0rem;
		}
	}
`;

const SectionWithImageAndCtaCard = ({ sectionWithImageAndCtaCardData }: { sectionWithImageAndCtaCardData: SectionWithImageAndCtaCardProps }) => {

	return (
		<>
			<Title_v2
				align={sectionWithImageAndCtaCardData.title.alignedAt}
				underlineColor={sectionWithImageAndCtaCardData.title.underlineColor}
				white={sectionWithImageAndCtaCardData.backgroundColor.color === 'prune'}
			>
				{renderUnderline(sectionWithImageAndCtaCardData.title.titlePieces)}
			</Title_v2>
			<TextWithImage
				backgroundImage={sectionWithImageAndCtaCardData.image.data.attributes.url}
				blockOrientation='row'
				isTextWhite={sectionWithImageAndCtaCardData.backgroundColor.color === 'prune'}
			>
				{sectionWithImageAndCtaCardData.sectionDescription}
			</TextWithImage>
			<CardsContainer>
				{sectionWithImageAndCtaCardData.cards.map(
					(card, index) => (
						<CtaCard
							card={card}
							key={index}
						/>
					),
				)}
			</CardsContainer>
		</>
	);
};

export default SectionWithImageAndCtaCard;
